var exports = {
  "vK": "BumpedBanner.module__banner___azR5T2",
  "FV": "BumpedBanner.module__belowBar___azR5T2",
  "Kk": "BumpedBanner.module__icon___azR5T2",
  "Qq": "BumpedBanner.module__text___azR5T2",
};

module.exports = exports;
